<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="business-outline"></ion-icon> Management Strategy</h4>
  </div>
  <div class="content-details">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Objective">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              The objective of Management and Strategy is to ensure the
              availability of a good organization that is duly supported by the
              management that is backed by a concrete strategy and vision. In
              this framework Management and Strategy refers to the method of
              establishing goals, procedures and objectives to increase the
              competitiveness of an organization.
            </li>
            <li>
              A strategic management considers how to best employ their manpower
              and utilise the assets to accomplish these objectives. Such a
              management frequently comprises strategic appraisal, internal
              organization analysis and strategy execution across the
              organization.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Phases">
        <div class="content-div p-4">
          <ul class="phases-ul">
            <li>
              An Incubation Center must first define its objectives clearly and
              specifically. Its objectives should explain what the Incubation
              Center hopes to accomplish and why. Once the objectives are
              defined, it can determine on the goals to be achieved. In this
              phase the Incubation Center can express its vision, short-term and
              long-term goals.
            </li>
            <li>
              Incubation Centers must be able to investigate, analyze and define
              how internal and external influences affecting their organization
              and its goals. They also come out with what is required to stay
              competitive. In this phase analytical methods such as SWOT
              (strengths, weaknesses, opportunities and threats) analysis will
              be used.
            </li>
            <li>
              The evaluation results can be used by the Incubation Centers to
              create a plan that specifies how it will execute its objectives.
              In this phase the business will determine the necessary personnel,
              equipment and other resources, define the distribution of various
              activities and the performance criteria that will be used to gauge
              success.
            </li>
            <li>
              Once the strategies are defined it is time for execution. In this
              phase, the allocated resources are in place for execution of the
              strategy based on their roles and responsibilities.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Scoring Criteria">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Management structure; Roles and responsibilities of the Director
              (or) CEO; Roles and responsibilities of the Incubation Manager;
              Support for Incubatees; Incubator Goals; Roles of the Management.
            </li>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
        <!-- <button class="ml-auto mb-3" mat-raised-button color="primary" (click)="saveBtn()">Save</button> -->
      </div>

      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="settingsForm"
        >
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Vision and Mission Statement of the Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true"> Question </span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.missionVisionStatus)"
                    [style.background]="pickColor(getValue.missionVisionStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.missionVisionStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>

              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Vision and Mission Statement of the Incubation Centre
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.missionVisionStatus != 2 &&
                        getValue.missionVisionStatus != 4 &&
                        getValue.missionVisionStatus != 5 &&
                        getValue.missionVisionStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="missionVisionIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsonechecked"
                          (change)="
                            showOptionsone(
                              $event.value,
                              '.upload0',
                              0,
                              '.set-succ0'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.missionVisionIncCentre.touched &&
                              setting.missionVisionIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.missionVisionIncCentre.touched &&
                            setting.missionVisionIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.missionVisionIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsonechecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="missionVisionUrlIcWebsite"
                                (change)="
                                  setStatus($event, 'missionVisionStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.missionVisionUrlIcWebsite.touched &&
                                    setting.missionVisionUrlIcWebsite.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.missionVisionUrlIcWebsite.touched &&
                                  setting.missionVisionUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.missionVisionUrlIcWebsite.errors
                                      .required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.missionVisionUrlIcWebsite.errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload0">
                                  <input
                                    type="file"
                                    formControlName="missionVisionImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.missionVisionImagefile
                                          .touched &&
                                        setting.missionVisionImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload0',
                                        0,
                                        '.set-succ0'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.missionVisionImagefile.touched &&
                                    setting.missionVisionImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.missionVisionImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload0"
                                  (click)="
                                    removeFile('.upload0', 0, '.set-succ0')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.missionVisionStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.missionVisionReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.missionVisionStatus == 2 ||
                        getValue.missionVisionStatus == 4 ||
                        getValue.missionVisionStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.missionVisionIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{ getValue.missionVisionUrlIcWebsite }}"
                                target="_blank"
                                >{{ getValue.missionVisionUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.missionVisionDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.missionVisionStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.missionVisionReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <!-- <mat-accordion>
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <div class="d-flex">
                                                        <span class="material-icons">fact_check</span> <span
                                                            class="ml-1">Scoring
                                                            Criteria</span>
                                                    </div>
                                                </mat-expansion-panel-header>
                                                <div class="scoring-div">
                                                    <ul>
                                                        <li *ngFor="let list of guidelineValue[0].ScoringCriteria">
                                                            {{list}}</li>
                                                    </ul>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion> -->
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Standard Operating Procedure for the Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.standardoperatingStatus)"
                    [style.background]="
                      pickColor(getValue.standardoperatingStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.standardoperatingStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Standard Operating Procedure for the Incubation Centre
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.standardoperatingStatus != 2 &&
                        getValue.standardoperatingStatus != 4 &&
                        getValue.standardoperatingStatus != 5 &&
                        getValue.standardoperatingStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="standardoperatingIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionstwochecked"
                          (change)="
                            showOptionstwo(
                              $event.value,
                              '.upload1',
                              1,
                              '.set-succ1'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.standardoperatingIncCentre.touched &&
                              setting.standardoperatingIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.standardoperatingIncCentre.touched &&
                            setting.standardoperatingIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.standardoperatingIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionstwochecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <!-- <div class="col-lg-6 col-md-6 col-12">
                                                        <mat-form-field class="material-full-width"
                                                            appearance="outline">
                                                            <mat-label>URL from Incubation Center Website <span
                                                                    class="text-danger">*</span></mat-label>
                                                            <input matInput placeholder="Enter URL from Incubation Center Website"
                                                                (change)="setStatus($event,'standardoperatingStatus',7)"
                                                                formControlName="standardoperatingUrlIcWebsite"
                                                                [ngClass]="{ 'is-invalid': setting.standardoperatingUrlIcWebsite.touched && 
                                                                setting.standardoperatingUrlIcWebsite.errors }">
                                                            <mat-error *ngIf="setting.standardoperatingUrlIcWebsite.touched && 
                                                                setting.standardoperatingUrlIcWebsite.errors">
                                                                <span
                                                                    *ngIf="setting.standardoperatingUrlIcWebsite.errors.required">URL
                                                                    from Incubation Center Website is
                                                                    required</span>
                                                                <span
                                                                    *ngIf="setting.standardoperatingUrlIcWebsite.errors.url">Please
                                                                    enter proper url
                                                                    format</span>
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div> -->
                          <div class="col-lg-12 col-md-12 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload1">
                                  <input
                                    type="file"
                                    formControlName="standardoperatingImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.standardoperatingImagefile
                                          .touched &&
                                        setting.standardoperatingImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload1',
                                        1,
                                        '.set-succ1'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.standardoperatingImagefile
                                      .touched &&
                                    setting.standardoperatingImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.standardoperatingImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload1"
                                  (click)="
                                    removeFile('.upload1', 1, '.set-succ1')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.standardoperatingStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.standardoperatingReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.standardoperatingStatus == 2 ||
                        getValue.standardoperatingStatus == 4 ||
                        getValue.standardoperatingStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.standardoperatingIncCentre }}</b>
                          </p>
                        </div>
                        <!-- <div class="sub-div">
                                                    <p class="p-lbl">URL from Incubation Center Website </p>
                                                    <ul class="web-ul">
                                                        <li>
                                                            <a href="{{getValue.standardoperatingUrlIcWebsite}}"
                                                                target="_blank">{{getValue.standardoperatingUrlIcWebsite}}</a>
                                                        </li>
                                                    </ul>
                                                </div> -->
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.standardoperatingdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.standardoperatingStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.standardoperatingReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <!-- <mat-accordion>
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <div class="d-flex">
                                                        <span class="material-icons">fact_check</span> <span
                                                            class="ml-1">Scoring
                                                            Criteria</span>
                                                    </div>
                                                </mat-expansion-panel-header>
                                                <div class="scoring-div">
                                                    <ul>
                                                        <li *ngFor="let list of guidelineValue[1].ScoringCriteria">
                                                            {{list}}</li>
                                                    </ul>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion> -->
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Short-term / Mid-term / Long-term goals established in
                    connection with Sustainability
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.shortMidLongStatus)"
                    [style.background]="pickColor(getValue.shortMidLongStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.shortMidLongStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Short-term / Mid-term / Long-term goals established in
                      connection with Sustainability
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.shortMidLongStatus != 2 &&
                        getValue.shortMidLongStatus != 4 &&
                        getValue.shortMidLongStatus != 5 &&
                        getValue.shortMidLongStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="shortMidLongIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsthreechecked"
                          (change)="
                            showOptionsthree(
                              $event.value,
                              '.upload2',
                              2,
                              '.set-succ2'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.shortMidLongIncCentre.touched &&
                              setting.shortMidLongIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.shortMidLongIncCentre.touched &&
                            setting.shortMidLongIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.shortMidLongIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsthreechecked">
                        <div class="main-wrapper" *ngSwitchCase="'Yes'">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload2">
                              <input
                                type="file"
                                formControlName="shortMidLongImagefile"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.shortMidLongImagefile.touched &&
                                    setting.shortMidLongImagefile.errors
                                }"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload2',
                                    2,
                                    '.set-succ2'
                                  )
                                "
                                id=""
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary
                              </span>
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Uploading</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.shortMidLongImagefile.touched &&
                                setting.shortMidLongImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.shortMidLongImagefile.errors.required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload2"
                              (click)="removeFile('.upload2', 2, '.set-succ2')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.shortMidLongStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="viewReasonBtn(getValue.shortMidLongReason)"
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.shortMidLongStatus == 2 ||
                        getValue.shortMidLongStatus == 4 ||
                        getValue.shortMidLongStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.shortMidLongIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.shortMidLongdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.shortMidLongStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.shortMidLongReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <!-- <mat-accordion>
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <div class="d-flex">
                                                        <span class="material-icons">fact_check</span> <span
                                                            class="ml-1">Scoring
                                                            Criteria</span>
                                                    </div>
                                                </mat-expansion-panel-header>
                                                <div class="scoring-div">
                                                    <ul>
                                                        <li *ngFor="let list of guidelineValue[2].ScoringCriteria">
                                                            {{list}}</li>
                                                    </ul>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion> -->
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Availability of an Advisory Board / Governance Body and
                    Project Management Committee (PMC)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.projectmanagementcommitteeStatus)
                    "
                    [style.background]="
                      pickColor(getValue.projectmanagementcommitteeStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.projectmanagementcommitteeStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>

              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Availability of an Advisory Board / Governance Body and
                      Project Management Committee (PMC)
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.projectmanagementcommitteeStatus != 2 &&
                        getValue.projectmanagementcommitteeStatus != 4 &&
                        getValue.projectmanagementcommitteeStatus != 5 &&
                        getValue.projectmanagementcommitteeStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="projectmanagementcommitteeIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfourchecked"
                          (change)="
                            showOptionsfour(
                              $event.value,
                              '.upload3',
                              3,
                              '.set-succ3'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.projectmanagementcommitteeIncCentre
                                .touched &&
                              setting.projectmanagementcommitteeIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.projectmanagementcommitteeIncCentre
                              .touched &&
                            setting.projectmanagementcommitteeIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.projectmanagementcommitteeIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsfourchecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                (change)="
                                  setStatus(
                                    $event,
                                    'projectmanagementcommitteeStatus',
                                    7
                                  )
                                "
                                formControlName="projectmanagementcommitteeUrlIcWebsite"
                                [ngClass]="{
                                  'is-invalid':
                                    setting
                                      .projectmanagementcommitteeUrlIcWebsite
                                      .touched &&
                                    setting
                                      .projectmanagementcommitteeUrlIcWebsite
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.projectmanagementcommitteeUrlIcWebsite
                                    .touched &&
                                  setting.projectmanagementcommitteeUrlIcWebsite
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting
                                      .projectmanagementcommitteeUrlIcWebsite
                                      .errors.required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting
                                      .projectmanagementcommitteeUrlIcWebsite
                                      .errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload3">
                                  <input
                                    type="file"
                                    formControlName="projectmanagementcommitteeImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .projectmanagementcommitteeImagefile
                                          .touched &&
                                        setting
                                          .projectmanagementcommitteeImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload3',
                                        3,
                                        '.set-succ3'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.projectmanagementcommitteeImagefile
                                      .touched &&
                                    setting.projectmanagementcommitteeImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting
                                        .projectmanagementcommitteeImagefile
                                        .errors.required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload3"
                                  (click)="
                                    removeFile('.upload3', 3, '.set-succ3')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.projectmanagementcommitteeStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.projectmanagementcommitteeReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.projectmanagementcommitteeStatus == 2 ||
                        getValue.projectmanagementcommitteeStatus == 4 ||
                        getValue.projectmanagementcommitteeStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.projectmanagementcommitteeIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.projectmanagementcommitteeUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.projectmanagementcommitteeUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.projectmanagementcommitteedocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.projectmanagementcommitteeStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.projectmanagementcommitteeReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <!-- <mat-accordion>
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <div class="d-flex">
                                                        <span class="material-icons">fact_check</span> <span
                                                            class="ml-1">Scoring
                                                            Criteria</span>
                                                    </div>
                                                </mat-expansion-panel-header>
                                                <div class="scoring-div">
                                                    <ul>
                                                        <li *ngFor="let list of guidelineValue[4].ScoringCriteria">
                                                            {{list}}</li>
                                                    </ul>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion> -->
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Board meetings conducted (Minimum two)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.boardmeetingsStatus)"
                    [style.background]="pickColor(getValue.boardmeetingsStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.boardmeetingsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <!-- (change)="setTable($event)" -->
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Board meetings conducted (Minimum two)</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.boardmeetingsStatus != 2 &&
                        getValue.boardmeetingsStatus != 4 &&
                        getValue.boardmeetingsStatus != 5 &&
                        getValue.boardmeetingsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="boardmeetingsIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfivechecked"
                          (change)="
                            showOptionsfive(
                              $event.value,
                              '.upload4',
                              4,
                              '.set-succ4'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.boardmeetingsIncCentre.touched &&
                              setting.boardmeetingsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.boardmeetingsIncCentre.touched &&
                            setting.boardmeetingsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.boardmeetingsIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsfivechecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <!-- <div class="col-lg-6 col-md-6 col-12">
                                                        <mat-form-field class="material-full-width"
                                                            appearance="outline">
                                                            <mat-label>Board Meetings Conducted Count <span
                                                                    class="text-danger">*</span></mat-label>
                                                            <input matInput
                                                                placeholder="Enter Board Meetings Conducted Count"
                                                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                                                formControlName="boardMeetingsConductedCount"
                                                                (change)="setStatus($event,'boardmeetingsStatus',7)"
                                                                [ngClass]="{ 'is-invalid': setting.boardMeetingsConductedCount.touched && setting.boardMeetingsConductedCount.errors }">
                                                            <mat-error
                                                                *ngIf="setting.boardMeetingsConductedCount.touched && setting.boardMeetingsConductedCount.errors">
                                                                <span
                                                                    *ngIf="setting.boardMeetingsConductedCount.errors.required">Board
                                                                    Meetings Conducted Count is
                                                                    required</span>
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div> -->
                          <div class="col-lg-12 col-md-12 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload4">
                                  <input
                                    type="file"
                                    formControlName="boardmeetingsImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.boardmeetingsImagefile
                                          .touched &&
                                        setting.boardmeetingsImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload4',
                                        4,
                                        '.set-succ4'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.boardmeetingsImagefile.touched &&
                                    setting.boardmeetingsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.boardmeetingsImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload4"
                                  (click)="
                                    removeFile('.upload4', 4, '.set-succ4')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="row" *ngSwitchCase="'Yes'">
                                                <div class="col-lg-6 col-md-6 col-12">
                                                    <div class="table-responsive" formGroupName="boardmeetingMinutes">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <td><label>No</label></td>
                                                                    <td><label>Minutes</label></td>
                                                                    <td class="text-center"><label>Action</label></td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let item of minutesList.controls; let i = index;"
                                                                    [formGroup]="item">
                                                                    <td>
                                                                        {{i+1}}
                                                                    </td>
                                                                    <td>
                                                                        <input class="form-input"
                                                                            (input)="setUpdate($event,i,'.set-succ5')"
                                                                            formControlName="minutes" [ngClass]="{
                                                                                'is-invalid': item.controls.minutes.touched && item.controls.minutes.errors
                                                                              }" type="text" placeholder="Minutes" />
                                                                        <div
                                                                            *ngIf="item.controls.minutes.touched && item.controls.minutes.errors">
                                                                            <span class="text-danger" *ngIf="item.controls.minutes.errors.required">
                                                                                Minutes is required
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td class="text-center">
                                                                        <ion-icon class="set-add-btn" name="add-circle-outline"
                                                                            (click)="addRow(i)"></ion-icon>
                                                                        <ion-icon class="set-delete-btn"
                                                                            name="close-circle-outline"
                                                                            (click)="deleteRow(i,'.set-succ5')"></ion-icon>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <mat-form-field class="material-full-width" appearance="outline">
                                                        <mat-label>Minutes<span class="text-danger">*</span></mat-label>
                                                        <input matInput placeholder="Enter Minutes"
                                                            formControlName="boardmeetingMinutes"
                                                            [ngClass]="{ 'is-invalid': setting.boardmeetingMinutes.touched && 
                                                            setting.boardmeetingMinutes.errors }">
                                                        <mat-error
                                                            *ngIf="setting.boardmeetingMinutes.touched && 
                                                            setting.boardmeetingMinutes.errors">
                                                            <span
                                                                *ngIf="setting.boardmeetingMinutes.errors.required">
                                                                Minutes</span>
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-12">
                                                   
                                                </div>
                                            </div> -->
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.boardmeetingsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.boardmeetingsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.boardmeetingsStatus == 2 ||
                        getValue.boardmeetingsStatus == 4 ||
                        getValue.boardmeetingsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.boardmeetingsIncCentre }}</b>
                          </p>
                        </div>
                        <!-- <div class="sub-div">
                                                    <p class="p-lbl">Board Meetings Conducted Count : <b>{{getValue.boardMeetingsConductedCount}}</b> </p>
                                                    
                                                </div> -->
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.boardmeetingsdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.boardmeetingsStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.boardmeetingsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <!-- <mat-accordion>
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <div class="d-flex">
                                                        <span class="material-icons">fact_check</span> <span
                                                            class="ml-1">Scoring
                                                            Criteria</span>
                                                    </div>
                                                </mat-expansion-panel-header>
                                                <div class="scoring-div">
                                                    <ul>
                                                        <li *ngFor="let list of guidelineValue[5].ScoringCriteria">
                                                            {{list}}</li>
                                                    </ul>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion> -->
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Quaterly review meetings with the Board / PMC
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.quaterlyreviewStatus)"
                    [style.background]="
                      pickColor(getValue.quaterlyreviewStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.quaterlyreviewStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Quaterly review meetings with the Board / PMC</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.quaterlyreviewStatus != 2 &&
                        getValue.quaterlyreviewStatus != 4 &&
                        getValue.quaterlyreviewStatus != 5 &&
                        getValue.quaterlyreviewStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="quaterlyreviewIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionssixchecked"
                          (change)="
                            showOptionssix(
                              $event.value,
                              '.upload5',
                              5,
                              '.set-succ5'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.quaterlyreviewIncCentre.touched &&
                              setting.quaterlyreviewIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.quaterlyreviewIncCentre.touched &&
                            setting.quaterlyreviewIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.quaterlyreviewIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionssixchecked">
                        <div class="main-wrapper" *ngSwitchCase="'Yes'">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload5">
                              <input
                                type="file"
                                formControlName="quaterlyreviewImagefile"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.quaterlyreviewImagefile.touched &&
                                    setting.quaterlyreviewImagefile.errors
                                }"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload5',
                                    5,
                                    '.set-succ5'
                                  )
                                "
                                id=""
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary
                              </span>
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Uploading</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.quaterlyreviewImagefile.touched &&
                                setting.quaterlyreviewImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.quaterlyreviewImagefile.errors
                                    .required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload5"
                              (click)="removeFile('.upload5', 5, '.set-succ5')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.quaterlyreviewStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.quaterlyreviewReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.quaterlyreviewStatus == 2 ||
                        getValue.quaterlyreviewStatus == 4 ||
                        getValue.quaterlyreviewStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.quaterlyreviewIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.quaterlyreviewdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.quaterlyreviewStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.quaterlyreviewReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <!-- <mat-accordion>
                                            <mat-expansion-panel>
                                                <mat-expansion-panel-header>
                                                    <div class="d-flex">
                                                        <span class="material-icons">fact_check</span> <span
                                                            class="ml-1">Scoring
                                                            Criteria</span>
                                                    </div>
                                                </mat-expansion-panel-header>
                                                <div class="scoring-div">
                                                    <ul>
                                                        <li *ngFor="let list of guidelineValue[6].ScoringCriteria">
                                                            {{list}}</li>
                                                    </ul>
                                                </div>
                                            </mat-expansion-panel>
                                        </mat-accordion> -->
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header class="d-flex">
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Enterprise Resource Planning / Project Management Tools
                    utilized
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.enterpriceresourceplanStatus)
                    "
                    [style.background]="
                      pickColor(getValue.enterpriceresourceplanStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.enterpriceresourceplanStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Enterprise Resource Planning / Project Management Tools
                      utilized
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.enterpriceresourceplanStatus != 2 &&
                        getValue.enterpriceresourceplanStatus != 4 &&
                        getValue.enterpriceresourceplanStatus != 5 &&
                        getValue.enterpriceresourceplanStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="enterpriceresourceplanCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionssevenchecked"
                          (change)="
                            showOptionsseven(
                              $event.value,
                              '.upload6',
                              6,
                              '.set-succ6'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.enterpriceresourceplanCentre.touched &&
                              setting.enterpriceresourceplanCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.enterpriceresourceplanCentre.touched &&
                            setting.enterpriceresourceplanCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.enterpriceresourceplanCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionssevenchecked">
                        <div class="main-wrapper" *ngSwitchCase="'Yes'">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload6">
                              <input
                                type="file"
                                formControlName="enterpriceresourceplanImagefile"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.enterpriceresourceplanImagefile
                                      .touched &&
                                    setting.enterpriceresourceplanImagefile
                                      .errors
                                }"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload6',
                                    6,
                                    '.set-succ6'
                                  )
                                "
                                id=""
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary
                              </span>
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Uploading</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.enterpriceresourceplanImagefile
                                  .touched &&
                                setting.enterpriceresourceplanImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.enterpriceresourceplanImagefile.errors
                                    .required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload6"
                              (click)="removeFile('.upload6', 6, '.set-succ6')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.enterpriceresourceplanStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.enterpriceresourceplanReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.enterpriceresourceplanStatus == 2 ||
                        getValue.enterpriceresourceplanStatus == 4 ||
                        getValue.enterpriceresourceplanStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.enterpriceresourceplanCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.enterpriceresourceplandocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.enterpriceresourceplanStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.enterpriceresourceplanReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Roles of the Management Team
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.rolemanangementteamStatus)
                    "
                    [style.background]="
                      pickColor(getValue.rolemanangementteamStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.rolemanangementteamStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Roles of the Management Team</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.rolemanangementteamStatus != 2 &&
                        getValue.rolemanangementteamStatus != 4 &&
                        getValue.rolemanangementteamStatus != 5 &&
                        getValue.rolemanangementteamStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="rolemanangementteamCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options8checked"
                          (change)="
                            showOptions8(
                              $event.value,
                              '.upload7',
                              7,
                              '.set-succ7'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.rolemanangementteamCentre.touched &&
                              setting.rolemanangementteamCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.rolemanangementteamCentre.touched &&
                            setting.rolemanangementteamCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.rolemanangementteamCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options8checked">
                        <div class="main-wrapper" *ngSwitchCase="'Yes'">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload7">
                              <input
                                type="file"
                                formControlName="rolemanangementteamImagefile"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.rolemanangementteamImagefile
                                      .touched &&
                                    setting.rolemanangementteamImagefile.errors
                                }"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload7',
                                    7,
                                    '.set-succ7'
                                  )
                                "
                                id=""
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary
                              </span>
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Uploading</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.rolemanangementteamImagefile.touched &&
                                setting.rolemanangementteamImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.rolemanangementteamImagefile.errors
                                    .required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload7"
                              (click)="removeFile('.upload7', 7, '.set-succ7')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.rolemanangementteamStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.rolemanangementteamReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.rolemanangementteamStatus == 2 ||
                        getValue.rolemanangementteamStatus == 4 ||
                        getValue.rolemanangementteamStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                        <!-- <p>19/01/2023,10.25 AM</p> -->
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.rolemanangementteamCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.rolemanangementteamdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.rolemanangementteamStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.rolemanangementteamReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
          <!-- <div class="text-right mt-3">
                        <button mat-raised-button color="primary">Save</button>
                    </div> -->
        </div>
      </div>
    </div>
  </div>
</section>
